export const ALLOWED_UPLOAD_IMAGES_MIME_TYPES =
  "image/png, image/jpeg, image/bmp";
